import { SessionLifecycleController } from '@adapters/controllers/SessionLifecycleController';
import type { SessionExpiredRecovery } from '@core/ports/SessionExpiredRecovery';
import { JourneyDraftStore } from '@infrastructure/storage/JourneyDraftStore';

export type SessionExpiredPageViewModel =
  | {
      kind: 'logged-out';
      title: 'You have been logged out';
      messages: readonly [string, string];
      actionLabel: 'Go back to login';
    }
  | {
      kind: 'recovery';
      title: string;
      messages: readonly [string, string];
      actionLabel: 'Log in again';
    };

export class SessionExpiredController {
  public constructor(
    private readonly sessionLifecycleController: SessionLifecycleController,
    private readonly sessionExpiredRecovery: SessionExpiredRecovery,
    private readonly journeyDraftStore: JourneyDraftStore
  ) {}

  public async enterPage(): Promise<SessionExpiredPageViewModel> {
    this.journeyDraftStore.clear();
    const snapshot = this.sessionLifecycleController.getSnapshot();

    if (snapshot.phase !== 'blocked') {
      return {
        kind: 'logged-out',
        title: 'You have been logged out',
        messages: [
          "For security, you're automatically logged out if you have not used the service for 10 minutes.",
          'If you were entering information, it has not been saved and you will need to re-enter it.'
        ],
        actionLabel: 'Go back to login'
      };
    }

    void this.sessionExpiredRecovery.returnOrFallback();

    return {
      kind: 'recovery',
      title: snapshot.title ?? 'Session expired',
      messages: [
        snapshot.message ?? 'Your session has ended due to inactivity.',
        'Log in again from the NHS App to continue using Intelligent Navigator.'
      ],
      actionLabel: 'Log in again'
    };
  }

  public async returnToNhsApp(): Promise<void> {
    await this.sessionExpiredRecovery.returnOrFallback();
  }
}